module.exports = __webpack_public_path__ + "static/img/faqs_header.821b383b.jpg";